module.exports = __webpack_public_path__ + "img/ai-logo.57f2fa09.png";